/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ComunicazioneEmailEsitoDTO } from './comunicazione-email-esito-dto';


export interface ComunicazioneEmailDettaglioDTO { 
    id?: string;
    comune_id?: string;
    /**
     * Nome del comune mittente; assente = mittente di piattaforma.
     */
    mittente_comune_nome?: string;
    /**
     * Assente dopo la scadenza della conservazione (vedi testo_rimosso_at).
     */
    oggetto?: string;
    /**
     * Corpo HTML sanitizzato, con i segnaposto non sostituiti; assente dopo la scadenza della conservazione.
     */
    corpo_html?: string;
    stato?: ComunicazioneEmailDettaglioDTOStatoEnum;
    destinatari_totali?: number;
    inviati?: number;
    falliti?: number;
    saltati_senza_email?: number;
    esiti_ignoti?: number;
    allegati_count?: number;
    allegati_bytes?: number;
    /**
     * Motivo a vocabolario chiuso, come nello storico.
     */
    errore?: string;
    created_at?: string;
    completato_at?: string;
    testo_disponibile_fino?: string;
    testo_rimosso_at?: string;
    actor_user_id?: string;
    /**
     * Presente solo per il SUPERADMIN.
     */
    actor_snapshot?: string;
    mittente_nome?: string;
    destinatari?: Array<ComunicazioneEmailEsitoDTO>;
}
export enum ComunicazioneEmailDettaglioDTOStatoEnum {
    IN_CORSO = 'IN_CORSO',
    COMPLETATO = 'COMPLETATO',
    FALLITO = 'FALLITO',
    INTERROTTO = 'INTERROTTO'
};



